import { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import { toast } from 'react-toastify';

function Register() {
  const [searchParams] = useSearchParams();
  const plan = (searchParams.get('plan') || 'A').toUpperCase(); // A | B

  const [joiningFee, setJoiningFee] = useState(plan === 'B' ? 10000 : 3100);
  const [form, setForm] = useState({
    fullName: '',
    mobile: '',
    email: '',
    password: '',
    confirmPassword: '',
    referralCode: '',
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Backend से Plan A / Plan B amount
  useEffect(() => {
    api
      .get('/AdminConfig/plans')
      .then((res) => {
        const plans = res.data?.plans || [];
        const selected = plans.find((p) => p.id === plan);
        if (selected?.amount != null) {
          setJoiningFee(Number(selected.amount));
        }
      })
      .catch(() => {
        // fail → default 3100 / 10000 already set
      });
  }, [plan]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.password !== form.confirmPassword) {
      toast.error('Password match नहीं हो रहा');
      return;
    }

    if (form.password.length < 6) {
      toast.error('Password कम से कम 6 characters का हो');
      return;
    }

    setLoading(true);
    try {
      const res = await api.post('/Auth/register', {
        fullName: form.fullName,
        mobile: form.mobile,
        email: form.email || null,
        password: form.password,
        referralCode: form.referralCode || null,
        plan: plan,
      });

      toast.success(res.data.message || 'Registration successful!');
      navigate('/payment');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4 py-8">
      <div className="bg-white rounded-2xl shadow-lg p-6 w-full max-w-md">
        <h2 className="text-2xl font-bold text-center text-blue-700 mb-1">
          Join KuberOne
        </h2>
        <p className="text-center text-gray-500 text-sm mb-1">
          Selected:{' '}
          <span className="font-bold text-blue-700">Plan {plan}</span>
        </p>
        <p className="text-center text-gray-500 text-sm mb-6">
          Joining Fee:{' '}
          <span className="font-bold text-gray-800">
            ₹{Number(joiningFee).toLocaleString('en-IN')}
          </span>
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            name="fullName"
            placeholder="Full Name"
            value={form.fullName}
            onChange={handleChange}
            required
            className="w-full border rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="tel"
            name="mobile"
            placeholder="Mobile Number"
            value={form.mobile}
            onChange={handleChange}
            required
            maxLength={10}
            className="w-full border rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="email"
            name="email"
            placeholder="Email (Optional)"
            value={form.email}
            onChange={handleChange}
            className="w-full border rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
            className="w-full border rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm Password"
            value={form.confirmPassword}
            onChange={handleChange}
            required
            className="w-full border rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="text"
            name="referralCode"
            placeholder="Referral Code (Optional)"
            value={form.referralCode}
            onChange={handleChange}
            className="w-full border rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white font-bold py-3 rounded-xl hover:bg-blue-700 disabled:opacity-50"
          >
            {loading
              ? 'Please wait...'
              : `Register (₹${Number(joiningFee).toLocaleString('en-IN')})`}
          </button>
        </form>

        <p className="text-center text-sm text-gray-500 mt-4">
          Already have account?{' '}
          <Link to="/login" className="text-blue-600 font-semibold">
            Login
          </Link>
        </p>
      </div>
    </div>
  );
}

export default Register;